<ion-app>
  @if (!isOnline()) {
    <div class="offline-banner">Sei offline, controlla la tua connessione a Internet.</div>
  }
  <ion-router-outlet></ion-router-outlet>
  <mau-environment-banner [environment]="environment"></mau-environment-banner>
</ion-app>
